/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A15Inputs */

const et_faq_a15 = /** @type {(inputs: Faq_A15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ScalingWebs erineb tavalisest agentuurist selle poolest, et meie fookus ei ole ainult disainil, klikkidel ega sisutootmisel, vaid süsteemil, mis ühendab veebilehe, SEO, Google Mapsi, AI-automaatika ja CRM-i üheks müügikanaliks. Me ei ehita lihtsalt ilusat kodulehte — me ehitame digitaalse süsteemi, mis aitab sinu ettevõttel olla nähtavam, usaldusväärsem ja lihtsamini ostetav. Eesmärk on rohkem kvaliteetseid päringuid ja parem tasuvus igast külastajast.`)
};

const en_faq_a15 = /** @type {(inputs: Faq_A15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ScalingWebs is different from a typical agency because our focus isn't only on design, clicks, or content production — it's on a system that combines your website, SEO, Google Maps, AI automation, and CRM into one sales channel. We don't just build a pretty website. We build a digital system that helps your business become more visible, more trusted, and easier to buy from. The goal is more high-quality inquiries and better return from every visitor.`)
};

/**
* | output |
* | --- |
* | "ScalingWebs is different from a typical agency because our focus isn't only on design, clicks, or content production — it's on a system that combines your we..." |
*
* @param {Faq_A15Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a15 = /** @type {((inputs?: Faq_A15Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A15Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a15(inputs)
	return en_faq_a15(inputs)
});